import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { useHomeBootstrap } from '../hooks/useHomeBootstrap';
const HomeFeatureFlagContext = createContext({});
export const HomeFeatureFlagProvider = ({ children }) => {
    const { flags } = useHomeBootstrap();
    const value = useMemo(() => ({ ...flags }), [flags]);
    return (_jsx(HomeFeatureFlagContext.Provider, { value: value, children: children }));
};
export const useHomeFeatureFlags = () => useContext(HomeFeatureFlagContext);
